import { gql } from "@apollo/client";

import { SUBACCOUNT_FIELDS } from "./fragments";

export const EDIT_SUBACCOUNT_SETTINGS = gql`
  mutation subaccountEditSettings(
    $name: String!
    $callbackNumber: String
    $subaccountId: ID!
    $collectCallerEmail: Boolean!
    $restrictExports: Boolean!
    $captchaRequired: Boolean!
  ) {
    subaccountEditName(subaccountId: $subaccountId, newName: $name) {
      id
      name
    }
    subaccountEditCallbackNumber(
      subaccountId: $subaccountId
      newCallbackNumber: $callbackNumber
    ) {
      id
      settings {
        callbackNumber
      }
    }
    subaccountEditCollectCallerEmail(
      subaccountId: $subaccountId
      collectCallerEmail: $collectCallerEmail
    ) {
      id
      settings {
        collectCallerEmail
      }
    }
    subaccountEditRestrictExports(
      subaccountId: $subaccountId
      restrictExports: $restrictExports
    ) {
      id
      settings {
        restrictExports
      }
    }
    subaccountEditCaptchaRequired(
      subaccountId: $subaccountId
      captchaRequired: $captchaRequired
    ) {
      id
      settings {
        captchaRequired
      }
    }
  }
`;

export const EDIT_SUBACCOUNT_CAMPAIGN_DEFAULTS = gql`
  ${SUBACCOUNT_FIELDS}
  mutation subaccountEditCampaignDefaults(
    $campaignDefaults: CampaignDefaultsInput!
    $subaccountId: ID!
    $confirmationTextAtTimeOfUpdate: String!
    $approverRole: String
  ) {
    subaccountEditCampaignDefaults(
      subaccountId: $subaccountId
      newCampaignDefaults: $campaignDefaults
      confirmationTextAtTimeOfUpdate: $confirmationTextAtTimeOfUpdate
      approverRole: $approverRole
    ) {
      ...SubaccountFields
    }
  }
`;

export const LIST_SUBACCOUNTS = gql`
  ${SUBACCOUNT_FIELDS}
  query listSubaccounts {
    listSubaccounts {
      ...SubaccountFields
    }
  }
`;

export const CREATE_SUBACCOUNT = gql`
  ${SUBACCOUNT_FIELDS}
  mutation subaccountCreate(
    $name: String!
    $defaultTimezone: String!
    $defaultAreaCode: String!
    $customer_profile_sid: String
    $approved_stir_shaken_sid: String
    $approved_voice_integrity_sid: String
    $approved_branded_calling_sid: String
    $approved_branded_calling_basic_sid: String
    $approval_requirement: ApprovalRequirement!
    $voicemail_allowed: Boolean!
    $confirmationTextAtTimeOfUpdate: String!
    $approverRole: String
  ) {
    subaccountCreate(
      name: $name
      defaultTimezone: $defaultTimezone
      defaultAreaCode: $defaultAreaCode
      customer_profile_sid: $customer_profile_sid
      approved_stir_shaken_sid: $approved_stir_shaken_sid
      approved_voice_integrity_sid: $approved_voice_integrity_sid
      approved_branded_calling_sid: $approved_branded_calling_sid
      approved_branded_calling_basic_sid: $approved_branded_calling_basic_sid
      approval_requirement: $approval_requirement
      voicemail_allowed: $voicemail_allowed
      confirmationTextAtTimeOfUpdate: $confirmationTextAtTimeOfUpdate
      approverRole: $approverRole
    ) {
      ...SubaccountFields
    }
  }
`;
